import { createPromiseClient } from '@bufbuild/connect';
import { ConnectTransportOptions } from '@bufbuild/connect-web';
import { LmsClickerAssessmentTeacherAPIServiceV1 } from '@protos/learning_management/lms.clickerAssessment.teacher.apis_connect';
import {
  ResponseStatusCodeFunction,
  lmsTransport,
  lmsTransportWithLogoutHandler,
} from './transports';

export const LmsClickerAssessmentTeacherAPIServiceV1Client =
  createPromiseClient(LmsClickerAssessmentTeacherAPIServiceV1, lmsTransport);

export const useLmsClickerAssessmentTeacherAPIServiceV1ClientWithStatusCodeHandler =
  (
    options: Partial<ConnectTransportOptions>,
    responseStatusCodeFunction: ResponseStatusCodeFunction
  ) =>
    createPromiseClient(
      LmsClickerAssessmentTeacherAPIServiceV1,
      lmsTransportWithLogoutHandler(options, responseStatusCodeFunction)
    );
